import gettext from '@sdk/lang/gettext';
import ConfirmModal from '@sdk/components/ui/confirmModal/ConfirmModal';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import { ButtonType } from '@sdk/components/ui/buttons/ButtonType';

import ExclamationMarkIcon from '@web/assets/svg/UI/exclamation-mark.svg';

import { Description, IconWrapper } from './bulkModeSubmitConfirmation.styles';

type Props = {
  counter: number;
  onClose: () => void;
  onConfirm: () => Promise<any>;
};

export const BulkModeSubmitConfirmation = ({ counter, onClose, onConfirm }: Props) => (
  <ConfirmModal
    buttonsPadding={0}
    dismissOnBackdropClick={false}
    fullScreen
    titleText={gettext('Please confirm')}
    titleThemeColor={ThemeColorType.primary}
    titleIcon={
      <IconWrapper>
        <ExclamationMarkIcon aria-hidden={true} />
      </IconWrapper>
    }
    primaryButtonText={gettext('Send')}
    primaryButtonType={ButtonType.primary}
    secondaryButtonText={gettext('Back')}
    dismiss={onClose}
    onPrimaryClick={onConfirm}
    zIndex={1045}>
    <Description>
      {gettext(
        'Psst! You are about to send this message to %(counter)s people through private conversations.',
        {
          counter,
        }
      )}
    </Description>
  </ConfirmModal>
);
